import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatOutOfWalletQuestion',
    standalone: false
})
export class FormatOutOfWalletQuestion implements PipeTransform {
    public transform(value: string): string {
        return value.replace(/^\d+\*/g, '');
    }
}